import { useSelector } from "react-redux";

import classes from "./header.module.scss";

const formatSeasonDateCompact = (value) => {
	if (!value) {
		return "";
	}

	const [year, month, day] = value.substr(0, 10).split("-");
	if (!year || !month || !day) {
		return "";
	}

	return `${day}/${month}/${year.slice(-2)}`;
};

const formatSeasonDateRange = (initialDate, endDate) => {
	const start = formatSeasonDateCompact(initialDate);
	const end = formatSeasonDateCompact(endDate);

	if (!start || !end) {
		return "";
	}

	return `${start} al ${end}`;
};

const HeaderSeasonIndicator = () => {
	const season = useSelector((state) => state.auth.season);

	if (!season?.label) {
		return null;
	}

	const dateRange = formatSeasonDateRange(season.initial_date, season.end_date);

	return (
		<div className={classes.seasonMenu}>
			<span className={classes.seasonMenuLabel}>Temporada {season.label}</span>
			{dateRange && <span className={classes.seasonMenuDates}>{dateRange}</span>}
		</div>
	);
};

export default HeaderSeasonIndicator;
